import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import activityLogRoutes from 'modules/activityLog/common/routing/routes'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const CesTestLogDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityLogCesTestLogDetails" */ 'modules/activityLog/details/CesTestLogDetails/pages/CesTestLogDetails'
    )
)

const CesTestLogDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:testId`} component={CesTestLogDetails} />
      <Redirect path='*' to={activityLogRoutes.root} />
    </Switch>
  </Suspense>
)

export default CesTestLogDetailsRouting
